module.exports = __webpack_public_path__ + "img/logo-cha-positive.svg";